import useSecuredApiService from './useSecuredApiService'

const useProductService = () => {
  const { getApiData, postApiData, deleteApiData, putApiData, getApiDataWithParams } =
    useSecuredApiService()

  const getPaged = async (params) => {
    return await getApiDataWithParams('/Product/getPaged', params)
  }

  const getSummaryById = async (id) => {
    var res = await getApiData('/Product/GetSummaryById?id=' + id)
    return res
  }

  const getById = async (id) => {
    var res = await getApiData('/Product/GetById?id=' + id)
    return res
  }

  const create = async (data) => {
    return postApiData('/Product', data)
  }

  const remove = async (id) => {
    return deleteApiData(`/Product/Delete?id=${id}`)
  }

  const update = async (id, data) => {
    return putApiData(`/Product/EditProduct?id=${id}`, data)
  }

  return {
    getPaged,
    getById,
    create,
    remove,
    update,
    getSummaryById,
  }
}

export default useProductService
